import styled from 'styled-components'

import { boxModelTypes, cssTypes, displayTypes, textTypes } from '../types'
import { boxModel, css, display, text } from '../util'

/**
 * @namespace Heading
 * @desc Primitive styled-component 💅
 * @return {Function} React component
 */
const Heading = styled.h2`
  ${boxModel};
  ${css};
  ${display};
  ${text};
`

/**
 * @name defaultProps
 * @memberof Heading
 * @desc Primitive's default properties
 */
Heading.defaultProps = {
  fontSize: 'baseFontSize',
  margin: [0],
  padding: [0],
  size: ['auto'],
}

/**
 * @name propTypes
 * @memberof Heading
 * @desc Primitive's prop type definitions
 */
Heading.propTypes = {
  ...boxModelTypes,
  ...cssTypes,
  ...displayTypes,
  ...textTypes,
}

/** @component */
export default Heading
